import { getCardRegistry } from '@/lib/cards';
import { UserInfoCard } from './UserInfoCard';
import { AccountStatusCard } from './AccountStatusCard';
import { RolesPermissionsCard, AdminActionsCard, OrgActionsCard } from './AllCards';
import { UserTelemetryCard } from './UserTelemetryCard';

/**
 * Register all user detail card components
 */
export function registerUserDetailCardComponents() {
  const registry = getCardRegistry();

  registry.register('user_detail.info', UserInfoCard);
  registry.register('user_detail.account_status', AccountStatusCard);
  registry.register('user_detail.roles_permissions', RolesPermissionsCard);
  registry.register('user_detail.admin_actions', AdminActionsCard);
  registry.register('user_detail.org_actions', OrgActionsCard);
  registry.register('user_detail.usage_telemetry', UserTelemetryCard);
}

export { UserInfoCard, AccountStatusCard, RolesPermissionsCard, AdminActionsCard, OrgActionsCard, UserTelemetryCard };
